module.exports = __webpack_public_path__ + "2afdfb4d9f9033c8e8d8abc8b0eae2d3.pdf";